import { ViewModel } from '../inputs/event/event.model';
import { AdvancedSettingsFormModel } from '../inputs/shared/components/advanced-settings-component/advanced-settings.component';

export const parseAdvancedDataForBE = ({
  internalItemId,
  language,
  publishedDate,
  visibility,
}: AdvancedSettingsFormModel): Pick<
  ViewModel,
  'externalId' | 'publishDate' | 'language' | 'orgContentMetadata'
> => ({
  externalId: internalItemId,
  publishDate: publishedDate,
  language: language?.id,
  orgContentMetadata: {
    hideFromCatalog: visibility?.hideFromCatalog ?? false,
    groupIds: visibility?.groups ?? [],
  },
});
